import { TablePagination, type TablePaginationProps } from "@mui/material";

import { useLocalizedTablePagination } from "@/hooks/useLocalizedTablePagination";

export const LocalizedTablePagination = (props: TablePaginationProps) => {
  const localizedProps = useLocalizedTablePagination();
  return <TablePagination {...props} {...localizedProps} />;
};
